import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import LazySection from "../Global/LazySection";
import ErrorBoundary from "../Global/ErrorBoundary";

// Lazy load components
const Footer = lazy(() => import("../Global/Footer"));
const GoToTop = lazy(() => import("../Global/GoToTop"));
const Dishes = lazy(() => import("./Dishes"));
const Howit = lazy(() => import("./Howit"));

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hang Tag Custom | Logo Woven Mina</title>
        <meta name="description" content="Hang tag custom untuk produk fashion dan garment Anda. Desain menarik, cetak berkualitas. Pesan hang tag di Logo Woven Mina." />
        <link rel="canonical" href="https://www.logowovenmina.com/hangtag" />
      </Helmet>
      <Preloader />
      <Header />
      <BredCrumb Title="Hangtag" subtitle="Hangtag" />
      <div className="page_wrapper">
        <LazySection minHeight="600px">
          <ErrorBoundary
            title="Model 3D tidak dapat dimuat"
            message="Perangkat Anda mungkin tidak mendukung tampilan 3D. Silakan lanjutkan scrolling untuk melihat konten lainnya."
          >
            <Suspense fallback={null}>
              <Howit />
            </Suspense>
          </ErrorBoundary>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Dishes />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </LazySection>

        <Suspense fallback={null}>
          <GoToTop />
        </Suspense>
      </div>
    </>
  );
};
export default Main;
